export const namespacesWithDDS = [
  'scp',
  'kyc',
];

export const sections = [
  {
    key: 'mineSites',
    label: 'Associated Mine Sites',
  },
  {
    key: 'suppliers',
    label: 'Identified Suppliers',
  },
  {
    key: 'customers',
    label: 'Identified Customers',
  },
];
